'use client';

/* eslint-disable react/button-has-type */
import BrandNewTemplate from '@wconcept/wconcept-ui-renewal/components/templates/BrandNewTemplate';
import Box from '@wconcept/wconcept-ui-renewal/src/components/atoms/Box';
import Text from '@wconcept/wconcept-ui-renewal/src/components/atoms/Text';
import BasicBtn from '@wconcept/wconcept-ui-renewal/src/components/molecules/_btn/BasicBtn';
import useHistoryRouter from '@hooks/useLinkTo';

export function BrandPageNone() {
  const { linkTo } = useHistoryRouter();

  return (
    <BrandNewTemplate className="brand-template">
      <Box className="empty-brand">
        <Text className="empty-text">
          해당 브랜드의 상품은
          <br />
          현재 구매할 수 없습니다.
        </Text>
        <BasicBtn
          type="lineIcon"
          className="btn-main"
          text="메인 이동하기"
          onClick={() => {
            linkTo.replace({
              url: '/rn/women',
            });
          }}
        />
      </Box>
    </BrandNewTemplate>
  );
}
